<!--
* @Author: xzh
* @Date: 2021-05-21 00:31:25
* @LastEditTime: 2021-05-21 10:09:32
* @LastEditors: xzh
* @Description: 组件描述
* @FilePath: /文件路径.vue
* 代码版权方：'政府采购信息网'
-->
<template>
 <el-scrollbar :native="false" style="width: 100%;height: 100%;">
    <el-main>
        <el-card>
            <template #header>
                订阅器
            </template>
            <el-input style="width: 200px; margin-right: 5px" placeholder="请输入手机号" prefix-icon="el-icon-search"
                  v-model="searchParams.tel" @keydown.enter.native="searchAction()"/>
            <el-input style="width: 200px; margin-right: 5px" placeholder="请输入用户id" prefix-icon="el-icon-search"
                  v-model="searchParams.userid" @keydown.enter.native="searchAction()"/>
            <el-select v-model="searchParams.pushMode" placeholder="推送模式" style="margin-right: 5px; margin-bottom: 5px" @change="searchAction()">
                <el-option v-for="item in pushModeType" :label="item.label" :value="item.value" :key="item.value"/>
            </el-select>
            <el-select v-model="searchParams.wechatPush" placeholder="微信推送" style="margin-right: 5px" @change="searchAction()">
                <el-option v-for="item in wechatPushType" :label="item.label" :value="item.value" :key="item.value"/>
            </el-select>
            <el-date-picker style="margin-right: 5px" align="right" type="daterange"
                start-placeholder="创建开始日期" range-separator="至" end-placeholder="创建结束日期"
                unlink-panels v-model="searchParams.createTimeRange" value-format="yyyy-MM-dd hh:mm:ss" @change="searchAction()"/>
            <el-date-picker style="margin-right: 5px" align="right" type="daterange"
                start-placeholder="最后推送开始日期" range-separator="至" end-placeholder="最后推送结束日期"
                unlink-panels v-model="searchParams.pushTimeRange" value-format="yyyy-MM-dd hh:mm:ss" @change="searchAction()"/>
            <el-button @click="searchAction" style="width: 150px;" type="primary">确定</el-button>
            <el-button @click="resetAction" style="width: 150px;" type="primary">重置</el-button>
            <el-table :data="tableData" style="width: 100%; margin-top: 20px;" border>
                <el-table-column prop="tel" label="手机号" width="" align="center"></el-table-column>
                <el-table-column prop="userid" label="用户id" align="center"></el-table-column>
                <el-table-column prop="pushMode" label="推送模式" width="" align="center">
                    <template slot-scope="scope">
                        {{makePushModeLabel(scope.row.pushMode)}}
                    </template>
                </el-table-column>
                <el-table-column prop="wechatPush" label="微信推送" width="" align="center">
                    <template slot-scope="scope">
                        {{makeWechatPushLabel(scope.row.wechatPush)}}
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="" align="center"></el-table-column>
                <el-table-column prop="lastPushTime" label="最后推送时间" width="" align="center"></el-table-column>
                <el-table-column prop="unreadNum" label="未读消息数量" width="" align="center"></el-table-column>
                <el-table-column label="操作" width="" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" @click="infoAction(scope.row)">详情</el-button>
                    </template>
                </el-table-column>
                
            </el-table>
            <el-pagination style="margin-top: 20px" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="searchParams.pageNum" :page-sizes="[5, 10, 15, 20]" :page-size="searchParams.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="total">
        </el-pagination>
        </el-card>
    </el-main>
    <subscriberDialog :visible.sync="dialogVisible" :before-close="handleClose" :info="subInfo"/>
 </el-scrollbar>
</template>
 
<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
// 例如：import 《组件名称》 from '《组件路径》';
import subscriberDialog from "@/components/subscriberDialog";
export default {
    components: {subscriberDialog},
    props: [],
    data () {
        return {
            searchParams:{
                tel:null,
                userid: null,
                pushMode: null,
                wechatPush: null,
                createTimeRange: [],
                startCreateTime: undefined,
                endCreateTime: undefined,
                pushTimeRange: [],
                startLastPushTime: undefined,
                endLastPushTime: undefined,
                pageNum: 1,
                pageSize: 10,
            },
            pushModeType: [
                {label:'定时推送', value: '0'},
                {label:'即时推送', value: '1'},
            ],
            wechatPushType: [
                {label:'否', value: '0'},
                {label:'是', value: '1'},
            ],
            tableData:[],
            total:0,
            dialogVisible: false,
            subInfo: {},
        }
    },
// 监听属性 类似于data概念
    computed: {}, 
// 监控data中的数据变化
    watch: {},
// 方法集合
    methods: {
        searchAction(val){
            if(val && val.length > 0){

            }else{
                this.searchParams.pageNum = 1;
            }
            if(this.searchParams.createTimeRange && this.searchParams.createTimeRange.length > 0) {
                this.searchParams.startCreateTime = this.searchParams.createTimeRange[0];
                this.searchParams.endCreateTime = this.searchParams.createTimeRange[1];
            }else{
                this.searchParams.startCreateTime = undefined;
                this.searchParams.endCreateTime = undefined;
            }
            if(this.searchParams.pushTimeRange && this.searchParams.pushTimeRange.length > 0) {
                this.searchParams.startLastPushTime = this.searchParams.pushTimeRange[0];
                this.searchParams.endLastPushTime = this.searchParams.pushTimeRange[1];
            }else{
                this.searchParams.startLastPushTime = undefined;
                this.searchParams.endLastPushTime = undefined;
            }
            this.searchParams.tel = this.searchParams.tel == '' ? null : this.searchParams.tel;
            this.searchParams.userid = this.searchParams.userid == '' ? null : this.searchParams.userid;
            this.searchParams.pushMode = this.searchParams.pushMode == '' ? null : this.searchParams.pushMode;
            this.searchParams.wechatPush = this.searchParams.wechatPush == '' ? null : this.searchParams.wechatPush;
            this.$request.querySubscribe(this.searchParams).then(response => {
                console.debug(response);
                if(response.status == 200){
                    this.tableData = response.data.list;
                    this.total = response.data.total;
                }else{
                    this.$message.error(response.message);
                }
            });
        },
        resetAction(){
            this.searchParams.tel = null;
            this.searchParams.userid = null;
            this.searchParams.pushMode = null;
            this.searchParams.wechatPush = null;
            this.searchParams.createTimeRange = [];
            this.searchParams.startCreateTime = undefined;
            this.searchParams.endCreateTime = undefined;
            this.searchParams.pushTimeRange = [];
            this.searchParams.startLastPushTime = undefined;
            this.searchParams.endLastPushTime = undefined;
            this.searchAction();
        },
        handleSizeChange(val){
            this.searchParams.pageSize = val;
            this.searchAction(' ');
        },
        handleCurrentChange(val){
            this.searchParams.pageNum = val;
            this.searchAction(' ');
        },
        makePushModeLabel(val){
            var label = '';
            this.pushModeType.forEach(item => {
                if (item.value == val){
                    label = item.label;
                }
            });
            return label;
        },
        makeWechatPushLabel(val){
            var label = '';
            this.wechatPushType.forEach(item => {
                if(item.value == val){
                    label = item.label;
                }
            });
            return label;
        },
        infoAction(val){
            this.$request.findSubscribeByUserId(val.userid).then(response => {
                if(response.status == 200){
                    this.dialogVisible = true;
                    this.subInfo = response.data;
                }else{
                    this.$message.error(response.message);
                }
            });
        }
    },
/*------生命周期-------*/
//创建完成（可以访问当前this实例）
    created() {},
//挂载完成（可以访问DOM元素）
    mounted() {
        this.searchAction();
    },
//创建之前
    beforeCreate() {},
//挂载之前
    beforeMount() {},
//更新之前
    updated() {},
//销毁之前
    beforeDestroy() {},
//销毁完成
    destroyed() {},
//如果页面有keep-alive缓存功能，这个函数会触发
    activated() {},
};
</script>
 
<style >

</style>